import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/auth/Auth'
import Home from '@/views/Home'
import Empresas from '@/views/Empresas'
import Usuarios from '@/views/Usuarios'
import Produtos from '@/views/Produtos'
import Totem from '@/views/Totem'
import Terminais from '@/views/Terminais'
import Pedidos from '@/views/Pedidos'
import Vouchers from '@/views/Vouchers'
import Midias from '@/views/Midias'
import SmartCity from '@/views/Pages/SmartCity'
import Upzz from '@/views/Pages/Upzz'
import RedeGP from '@/views/Pages/RedeGP'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
  { name: 'usuarios', path: '/usuarios', component: Usuarios, meta: { requiresAdmin: true } },
  { name: 'produtos', path: '/produtos', component: Produtos, meta: { requiresAdmin: true } },
  { name: 'totem', path: '/totem', component: Totem, meta: { requiresAdmin: true } },
  { name: 'terminais', path: '/terminais', component: Terminais, meta: { requiresAdmin: true } },
  { name: 'pedidos', path: '/pedidos', component: Pedidos, meta: { requiresAdmin: true } },
  { name: 'vouchers', path: '/vouchers', component: Vouchers, meta: { requiresAdmin: true } },
  { name: 'midias', path: '/midias', component: Midias, meta: { requiresAdmin: true } },
  { name: 'smartcity', path: '/smartcity', component: SmartCity, meta: { requiresAdmin: false } },
  { name: 'upzz', path: '/upzz', component: Upzz, meta: { requiresAdmin: false } },
  { name: 'redegp', path: '/redegp', component: RedeGP, meta: { requiresAdmin: false } },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "TOTEM")
      next()
    else
      next({ path: '/' })
  } else {
    next()
  }
})

export default router
